import request from '../request'



//好友列表
export function friendlist(data) {
    return request({
        url: '/web/friend/list',
        method: 'GET',
        params: data
    })
}

//删除好友
export function frienddel(data) {
    return request({
        url: '/web/friend/del',
        method: 'POST',
        data
    })
}

//添加好友
export function addfriend(data) {
    return request({
        url: '/web/friend/add',
        method: 'POST',
        data
    })
}

//关注我的
export function fanslist(data) {
    return request({
        url: '/web/fans/list',
        method: 'GET',
        params: data
    })
}

//我关注的
export function followlist(data) {
    return request({
        url: '/web/follow/list',
        method: 'GET',
        params: data
    })
}

//关注
export function followoption(data) {
    return request({
        url: '/web/follow/option',
        method: 'POST',
        data
    })
}

//取关
export function followupdate(data) {
    return request({
        url: '/web/follow/update',
        method: 'POST',
        data
    })
}

//我的推广
export function extensionlist(data) {
    return request({
        url: '/web/extension/list',
        method: 'GET',
        params: data
    })
}

//推广删除
export function extensiondel(data) {
    return request({
        url: '/web/extension/del',
        method: 'POST',
        data
    })
}

//我的团队
export function corporationlist(data) {
    return request({
        url: '/web/extension/corporation/list',
        method: 'GET',
        params: data
    })
}

//我的企业
export function followcompanyList(data) {
    return request({
        url: '/web/extension/follow/companyList',
        method: 'GET',
        params: data
    })
}

//工作记录
export function MyCompanyList(data) {
    return request({
        url: '/web/extension/MyCompanyList',
        method: 'GET',
        params: data
    })
}

//企业详情
export function companyinfo(data) {
    return request({
        url: '/web/company/info',
        method: 'GET',
        params: data
    })
}

//企业详情-职位列表
export function joblist(data) {
    return request({
        url: '/web/company/job/list',
        method: 'GET',
        params: data
    })
}

//企业详情-项目列表
export function projectlist(data) {
    return request({
        url: '/web/company/project/list',
        method: 'GET',
        params: data
    })
}

//企业详情-主管列表
export function userlist(data) {
    return request({
        url: '/web/company/user/list',
        method: 'GET',
        params: data
    })
}

//企业关注-取关
export function companyfollow(data) {
    return request({
        url: 'web/company/follow',
        method: 'POST',
        data
    })
}

//个人中心
export function userinfo(data) {
    return request({
        url: '/web/user/info',
        method: 'GET',
        params: data
    })
}

//工作台密码设置
export function usergallery(data) {
    return request({
        url: '/web/user/gallery',
        method: 'POST',
        data
    })
}

//手机号获取
export function getgalleryForgot(data) {
    return request({
        url: '/web/user/get/galleryForgot',
        method: 'GET',
        params: data
    })
}

//工作台密码找回
export function setgalleryForgot(data) {
    return request({
        url: '/web/user/set/galleryForgot',
        method: 'POST',
        data
    })
}

//登录密码修改
export function syatempassword(data) {
    return request({
        url: '/web/user/syatem/password',
        method: 'POST',
        data
    })
}

//更换手机号
export function mobileupdate(data) {
    return request({
        url: '/web/user/mobile/update',
        method: 'POST',
        data
    })
}

//个人信息保存
export function userstore(data) {
    return request({
        url: '/web/user/store',
        method: 'POST',
        data
    })
}

//红包记录
export function redpackList(data) {
    return request({
        url: '/web/user/redpack/List',
        method: 'GET',
        params: data
    })
}

//红包领取
export function redpackdraw(data) {
    return request({
        url: '/web/user/redpack/draw',
        method: 'POST',
        data
    })
}
